// extracted by mini-css-extract-plugin
export default {"clearFiltersWrapper":"ClearFilters_clearFiltersWrapper__aOrNt","clearFiltersText":"ClearFilters_clearFiltersText__CW3y-","clearFiltersImg":"ClearFilters_clearFiltersImg__g63Tp"};